import { render, staticRenderFns } from "./PanelMetro.vue?vue&type=template&id=1204452c&"
import script from "./PanelMetro.vue?vue&type=script&lang=js&"
export * from "./PanelMetro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports